async function retryAsync(fn, options = {}) {
  const {
    retries = 3,
    delayMs = 1e3,
    onError,
    retryCondition = () => true
  } = options;
  let lastError;
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      onError?.(error, attempt);
      const shouldRetry = attempt < retries && retryCondition(error);
      if (!shouldRetry) break;
      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
  }
  throw lastError;
}

export { retryAsync };
//# sourceMappingURL=src-util-retry-async.js.map
